
import PageHeader from '@/components/core/PageHeader';
import ReviewCard from '@/components/ReviewSection/ReviewCard'
import tableLoading from '@/components/tableLoading';
export default {
  layout: 'direct-content',
  scrollToTop: true,
  components: {
    PageHeader,
    tableLoading,
    ReviewCard
  },
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
          hid: 'og:title',
          property: 'og:title',
          content: this.title + " | Goa App"
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title + " | Goa App"
        }
      ],

    }
  },
  data() {
    return {
      title: 'What Our Clients Say',
      loading: true,
      reviews: null
    }
  },
  fetchOnServer: false,
  async fetch() {
    this.reviews = await fetch(this.$config.fetchUrl + '/api/testimonials/app/getFeatured').then(res => res.text());
    this.reviews = this.getCryptKey(this.reviews);
    this.$nextTick(() => {  this.loading = false;  })
  }
}

